import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import {
  GetMyOrganizationParams,
  GetOrganizationsResult,
  MyOrganization,
} from '@/features/organization/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const organizationApi = createApi({
  reducerPath: 'organizationApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/organization',
  }),
  tagTypes: ['Organization'],
  endpoints: builder => ({
    getMyOrganization: builder.query<MyOrganization, GetMyOrganizationParams>({
      query: params => ({
        url: '',
        params,
      }),
      providesTags: ['Organization'],
    }),
    /** Every organization known to the platform — powers the connection-application form's
     * organization picker, since an applicant has no organization of their own yet to scope by. */
    getOrganizations: builder.query<GetOrganizationsResult, void>({
      query: () => ({ url: '/all' }),
    }),
  }),
});

export const { useGetMyOrganizationQuery, useGetOrganizationsQuery } = organizationApi;
